import React from 'react';
import PropTypes from 'prop-types';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SelectField from 'components/input/SelectField/SelectField';
import TextToArrayFilter from 'components/list/Filters/types/TextToArrayFilter';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import CategoryIdFilter from 'components/form/filters/CategoryIdFilter';
import SubCategoryIdFilter from 'components/form/filters/SubCategoryIdFilter';
import PointOfInterestIdFilter from 'components/form/filters/PointOfInterestIdFilter';
import ProviderIdFilter from 'components/form/filters/ProviderIdFilter';
import TitleFilter from 'components/form/filters/TitleFilter';

const ProductIdComponent = <TextToArrayFilter
    label='resources.products.fields.id'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='id'
/>;

const EnabledFilter = <SelectField
    label='filters.components.enabled.label'
    source='enabled'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: '1',
            name: 'filters.components.enabled.choices.active',
        },
        {
            id: '0',
            name: 'filters.components.enabled.choices.inactive',
        },
    ] }
/>;

const IsCombinedProductFilter = <SelectField
    label='resources.products.fields.is_combined'
    source='is_combined_product'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: '1',
            name: 'resources.general.fields.boolean.yes',
        },
        {
            id: '0',
            name: 'resources.general.fields.boolean.no',
        },
    ] }
/>;

const RadiusFilter = <SelectField
    label='resources.products.fields.radius'
    source='radius'
    fullWidth={ true }
    floatingLabelFixed={ true }
    choices={ [
        {
            id: 5,
            name: 'resources.products.filters.radius.5',
        },
        {
            id: 10,
            name: 'resources.products.filters.radius.10',
        },
        {
            id: 15,
            name: 'resources.products.filters.radius.15',
        },
        {
            id: 20,
            name: 'resources.products.filters.radius.20',
        },
        {
            id: 25,
            name: 'resources.products.filters.radius.25',
        },
    ] }
/>;

const ProductsListFilters = (props) => {
    const filters = {
        basic: {
            enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            title: {
                component: TitleFilter,
                matchTypes: {
                    default: filterMatchTypes.contains,
                    values: [
                        filterMatchTypes.contains,
                        filterMatchTypes.endsWith,
                        filterMatchTypes.equals,
                        filterMatchTypes.startsWith,
                    ],
                },
            },
            id: {
                component: ProductIdComponent,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
        },
        advanced: {
            enabled: {
                component: EnabledFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            category_id: {
                component: CategoryIdFilter,
                matchTypes: {
                    default: filterMatchTypes.matchOneOf,
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            is_combined_product: {
                component: IsCombinedProductFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            subcategory_id: {
                component: SubCategoryIdFilter,
                matchTypes: {
                    default: filterMatchTypes.matchOneOf,
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            provider_id: {
                component: ProviderIdFilter,
                matchTypes: {
                    default: filterMatchTypes.equals,
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            point_of_interest_id: {
                component: PointOfInterestIdFilter,
                matchTypes: {
                    default: filterMatchTypes.near,
                    values: [
                        filterMatchTypes.near,
                    ],
                },
            },
            radius: {
                component: RadiusFilter,
                matchTypes: {
                    default: filterMatchTypes.range,
                    values: [
                        filterMatchTypes.range,
                    ],
                },
            },
        },
    };

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

ProductsListFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default ProductsListFilters;



// WEBPACK FOOTER //
// ./src/pages/products/list/ProductsListFilters.js